/**
 * admin_activity_logs_controller.js — Activity logs page (Stimulus).
 *
 * Ports the former static/js/admin_activity_logs.js
 * (attachOnce('activityLogsListeners') + turbo:load) to an element-scoped
 * controller. The only behaviour is the "exclude demo" toggle, which navigates
 * to the activity-logs URL with the new ?exclude_demo flag.
 *
 * Lifecycle (replaces attachOnce + turbo:load):
 *   connect() binds the change listener on #excludeDemoToggle; disconnect()
 *   removes it. Because the controller instance owns add+remove, the listener
 *   cannot stack across Turbo navigations — the failure attachOnce hand-rolled.
 *
 * data-controller="admin-activity-logs" hosts on the page's container-fluid,
 * which carries data-activity-logs-url (the base URL the refresh navigates to).
 *
 * Template: templates/admin/activity_logs.html
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
        connect() {
            this._toggle = document.getElementById('excludeDemoToggle');
            if (!this._toggle) return;
            this._onChange = () => this.refresh();
            this._toggle.addEventListener('change', this._onChange);
        }

        disconnect() {
            if (this._toggle && this._onChange) {
                this._toggle.removeEventListener('change', this._onChange);
            }
            this._toggle = null;
            this._onChange = null;
        }

        refresh() {
            const baseUrl = this.element.dataset.activityLogsUrl || window.location.pathname;
            const excludeDemo = document.getElementById('excludeDemoToggle').checked;
            window.Turbo.visit(baseUrl + '?exclude_demo=' + excludeDemo);
        }
}
